'use strict';
var globalThis = require('../internals/global-this');
var setToStringTag = require('../internals/set-to-string-tag');

// JSON[@@toStringTag] property
// https://tc39.es/ecma262/#sec-json-@@tostringtag
setToStringTag(globalThis.JSON, 'JSON', true);



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/modules/es.json.to-string-tag.js
// module id = 272
// module chunks = 13